export * from './post-herausgeber-request.interface';
export * from './post-herausgeber-response.interface';
export * from './post-herausgeber.shapes';
